import { ReduxUtils, Consts } from '../dependencies';

export const routePaths = ReduxUtils.strictObjectAccess({
    REPORTS: Consts.routes.REPORTS,
    REPORT: Consts.routes.REPORT,
    REPORT_NEW: '/reports/new',
});
